import React, { lazy, Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import MomentUtils from '@date-io/moment'
import { CircularProgress } from '@material-ui/core'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import { componentMapping } from './componentImports'
import wrappedRoutes from './routes.json'
const Pdf = lazy(() => import('../components/OSSIF/Agenzie/Pdf/Pdf'))
const UserInfo = lazy(() => import('../container/UserInfo'))
const OSSIFLogin = lazy(() => import('../container/OSSIFLogin'))
const OSSIFLoginAs = lazy(() => import('../container/OSSIFLoginAs'))
const ResetPasswordConfirm = lazy(
  () => import('../container/ResetPasswordConfirm')
)

const RctThemeProvider = lazy(() => import('../container/RctThemeProvider'))
const NotificationContainer = lazy(() =>
  import('react-notifications').then((module) => ({
    default: module.NotificationContainer
  }))
)
const RctAppLayout = lazy(() => import('Components/RctAppLayout'))
const ProtectedRoute = lazy(() => import('./ProtectedRoute'))
const App = () => {
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Suspense fallback={<CircularProgress />}>
        <RctThemeProvider>
          <NotificationContainer />
          <Switch>
            <Redirect exact from={`/`} to={`/home`} />
            <Route path="/signin" component={OSSIFLogin} />
            <Route path="/signinas" component={OSSIFLoginAs} />
            <Route
              path="/recuperapassword/:id"
              component={ResetPasswordConfirm}
            />

            <Route path="/info/landing" component={UserInfo} />
            <Route path="/pdf/:id" component={Pdf} />
            <Route
              path="/error"
              component={componentMapping['AsyncOssifErrorComponent']}
            />

            <Route
              path="/"
              render={() => (
                <RctAppLayout>
                  <Switch>
                    {wrappedRoutes.map((route, index) => {
                      const { path, component, isProtected } = route
                      const Component = componentMapping[component]

                      return isProtected ? (
                        <ProtectedRoute
                          key={index}
                          path={path}
                          component={Component}
                        />
                      ) : (
                        <Route key={index} path={path} component={Component} />
                      )
                    })}
                    <Route path="*">
                      <Redirect to="/" />
                    </Route>
                  </Switch>
                </RctAppLayout>
              )}
            />
          </Switch>
        </RctThemeProvider>
      </Suspense>
    </MuiPickersUtilsProvider>
  )
}

export default App
